 <template>
  <v-container style="width: 900px">
    <v-data-table
        :headers="headersTimeReportSummary"
        :items="items"
        :item-class="disabledRow"
    >
      <template v-slot:item.quantity="{ item }">
        <span>{{ parseFloat(item.quantity).toFixed(2) }}</span>
      </template>
      <template v-slot:item.uom="{ item }">
        <span>
          {{ typeof (item.uom) === "object" ? languageData.measureTypes[item.uom.value] : languageData.measureTypes[item.uom] }}
        </span>
      </template>
      <template v-slot:item.price="{ item }">
        <span>{{ parseFloat(item.price).toFixed(2) + '€' }}</span>
      </template>
      <template v-slot:item.totalNet="{ item }">
        {{ parseFloat(item.totalNet).toFixed(2) + '€' }}
      </template>
      <template v-slot:item.vat="{ item }">
          <span>{{ item.vat + '%' }}</span>
      </template>
      <template v-slot:item.vatCost="{ item }">
        <span>
          {{ parseFloat(item.vatCost).toFixed(2) + '€' }}
        </span>       
      </template>
      <template v-slot:item.totalGross="{ item }">
        <span>
          {{ parseFloat(item.totalGross).toFixed(2) + '€' }}
        </span>          
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          :disabled="item.selected"
          @click="addTimeReportItem(item)"
          icon
          large>
          <v-icon color="primary">add</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script type="text/javascript">
import {mapState} from 'vuex';
import eventBus from "../../../../event-bus/eventBus";

export default {
  name: "TimeReportSummaryItemsTable",
  props: {
    timeReportSummaryItems: Array,
  },
  data() {
    return {
      items: [],
    }
  },
  computed: {
    ...mapState("getHeadersTimeReportSummary", {
      headersTimeReportSummary: state => state.headersTimeReportSummary,
    }),
  },
  methods: {
    addTimeReportItem(item) {
      item.selected = true;
      eventBus.$emit('addEstimationItem', {item, isMeasurement: false});
    },
    disabledRow(item) {
      return item.selected ? 'grey lighten-3 grey--text' : null;
    }
  },
  mounted() {
    this.items = this.timeReportSummaryItems; 
    eventBus.$on('deleteTimeReportSummaryItem', (timeReportItemId) => {
      const item = this.items.find(el => el.timeReportItemId === timeReportItemId);
      if (item) {
        item.selected = false;
      }
    })
  },
}
</script>